// extracted by mini-css-extract-plugin
module.exports = {"sentiment-tracker":"sentiment-tracker_sentiment-tracker__0iZuV","question":"sentiment-tracker_question__9AQHs","buttons":"sentiment-tracker_buttons__cucit"};